import { useQuery } from '@tanstack/react-query'
import { getDemandHistoryById } from 'services/demands/demandsServices'

export default function useDemandHistory(id) {
	const { data, isLoading, isError, error } = useQuery({
		queryKey: ['demand-history', id],
		queryFn: () => getDemandHistoryById(id),
		enabled: !!id,
		staleTime: 1000 * 30,
		refetchOnWindowFocus: true,
		retry: false,
	})

	return { data, isLoading, isError, error }
}
